/**
 * @FileDescription: 数据中心
 */
import axios from '@/api/utils/axios';

const CompanyReportApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/report/platform/data/center';
	},
	/**
	 * @description: 获取首页banner统计值
   * @param {Object} data { year, month }
	 */
	getReportByLogin: function(data) {
		return axios.post(this.baseUrl() + "/getReportByLogin", data);
	},
};

export default CompanyReportApi;
